﻿import { useNavigate } from "react-router-dom";

export function useFormSubmit(agreed: boolean) {
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    if (!agreed) {
      e.preventDefault();
      alert("Debes aceptar la Politica de Privacidad para enviar el formulario.");
      return;
    }

    e.preventDefault();
    const form = e.currentTarget;
    if (!form) return;

    const formData = new FormData(form);
    
    // Remove _gotcha if empty (honeypot)
    if (!formData.get("_gotcha")) {
      formData.delete("_gotcha");
    }

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: formData,
        headers: {
          "Accept": "application/json"
        }
      });

      if (response.ok) {
        navigate("/gracias/");
      } else {
        alert("Error al enviar el formulario. Intentelo de nuevo.");
      }
    } catch (error) {
      // If fetch fails, still navigate to gracias
      navigate("/gracias/");
    }
  };

  return handleSubmit;
}